import React from "react";
import { BaseCompletionCard } from "../BaseCompletionCard";
import { DocumentExpiryCompletionCardProps } from "./types";

export const DocumentExpiryCompletionCard = ({
  profileName,
  onClose,
}: DocumentExpiryCompletionCardProps) => {
  return (
    <BaseCompletionCard
      title={`${profileName}'s document update is complete`}
      onClose={onClose}
    />
  );
};
